export type AdminSignInValueObject = {
    id: bigint
    adminId: bigint
    createdAt: Date
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace AdminSignInValueObject {
    export function construct(o: any): AdminSignInValueObject {
        return {
            id: BigInt(o.id),
            adminId: BigInt(o.adminId),
            createdAt: new Date(o.createdAt),
        }
    }

    export const description: Record<keyof AdminSignInValueObject, string> = {
        id: '기본키',
        adminId: '사용자 기본키',
        createdAt: '생성일시'
    }
}